import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  DialogActions,
  Button,
  Typography,
  Divider,
} from '@mui/material';
import { useLang } from '../../contexts/langContext';
import { PptxFile } from '../../types/index';

interface PptxFilePickerDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (fileId: string) => void;
  pptxFiles: PptxFile[];
  currentFileId?: string;
}

function PptxFilePickerDialog({ open, onClose, onSelect, pptxFiles, currentFileId }: PptxFilePickerDialogProps) {
  const { lang } = useLang();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {lang === 'en' ? 'Select PPTX Template' : '选择 PPTX 模板'}
      </DialogTitle>
      <DialogContent>
        {pptxFiles.length === 0 ? (
          <Typography color="text.secondary">
            {lang === 'en' ? 'No PPTX templates available' : '没有可用的 PPTX 模板'}
          </Typography>
        ) : (
          <List>
            {pptxFiles.map((file, index) => (
              <React.Fragment key={file._id}>
                <ListItem disablePadding>
                  <ListItemButton 
                    onClick={() => onSelect(file._id)}
                    selected={file._id === currentFileId}
                  >
                    <ListItemText
                      primary={file.filename}
                      secondary={
                        <>
                          <Typography component="span" variant="body2" color="text.secondary">
                            {new Date(file.createdAt).toLocaleString()}
                          </Typography>
                          {file.description && (
                            <Typography 
                              component="span" 
                              variant="body2" 
                              color="text.secondary" 
                              sx={{ 
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                mt: 0.5
                              }}
                            >
                              {file.description}
                            </Typography>
                          )}
                        </>
                      }
                    />
                  </ListItemButton>
                </ListItem>
                {index < pptxFiles.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {lang === 'en' ? 'Cancel' : '取消'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PptxFilePickerDialog; 